module.exports = __webpack_public_path__ + "img/NAPASCREDIT.a5c33653.svg";